import { ColTypeDef, ValueFormatterParams } from 'ag-grid-community';
import { OrderType } from 'apiConnector/secondary-market/batch/model';
import { useSPIntl } from 'hooks/useIntl';
import { IntlKey } from 'locales';
import { useMemo } from 'react';
import { OperationStatusCellRenderer } from 'routes/secondary-market-batch/grid/components/operation-status-cell-renderer';
import { RowData } from 'state/workspaces/secondary-market/batch/model';

function getLabelForStatus(status: RowData['operationStatus'], orderType: OrderType): IntlKey | undefined {
  switch (status) {
    case 'NotReady':
      return 'secondary-market-batch-grid.operation.status.not-ready';
    case 'Ready':
      return 'secondary-market-batch-grid.operation.status.ready';
    case 'Loading':
    case 'InProgress':
      return 'secondary-market-batch-grid.operation.status.loading';
    case 'Rejected':
      return 'secondary-market-batch-grid.operation.status.rejected';
    case 'Expired':
      return 'secondary-market-batch-grid.operation.status.expired';
    case 'Quoted':
      return 'secondary-market-batch-grid.operation.status.quoted';
    case 'Success':
      return orderType === 'ebiz-quote'
        ? 'secondary-market-batch-grid.operation.status.traded'
        : 'secondary-market-batch-grid.operation.status.order-placed';
    default:
      return undefined;
  }
}

export function useOperationStatus(orderType: OrderType) {
  const { formatMessage } = useSPIntl();
  return useMemo(
    () =>
      ({
        cellRenderer: OperationStatusCellRenderer,
        cellClass: 'p-0',
        useValueFormatterForExport: true,
        valueFormatter: ({ value }: ValueFormatterParams<RowData>) => {
          return formatMessage({ id: getLabelForStatus(value, orderType) ?? value });
        },
      }) satisfies ColTypeDef<RowData, RowData[keyof RowData]>,
    [formatMessage, orderType],
  );
}
